import { Vector3 } from "three";
import { BOOTH_POSITIONS } from "../configs/BOOTH_POSITIONS";

const calculateBoothPositions = () => {
  const values = BOOTH_POSITIONS;
  const boothsArray = [];
  for (let i = 0; i < values.length; i++) {
    const positionX = values[i].position[0];
    const positionY = values[i].position[1];
    const positionZ = values[i].position[2];
    const boothCoordinates = new Vector3(positionX, positionY, positionZ);
    boothsArray.push(boothCoordinates);
  }
  return boothsArray;
};

export default calculateBoothPositions;
